export var stackingOrder = {
  behind: -1,
  infront: 1,
  dropdown: 1000,
  searchBar: 1050,
  topBar: 1100,
  modal: 1300,
  tooltip: 1500,
  popUp: 1600
};
export default stackingOrder;